import { parseDateInput } from './formatters';

function normalizeTierName(tierName) {
  if (!tierName) return 'free';
  return String(tierName).toLowerCase();
}

export function isMembershipExpired(expiresAt, tierName = 'free') {
  const normalizedTierName = normalizeTierName(tierName);
  if (normalizedTierName === 'free') return false;

  const expiresAtDate = parseDateInput(expiresAt);
  if (!expiresAtDate) return false;

  return expiresAtDate.getTime() <= Date.now();
}

export function getMembershipState(membership) {
  const rawTierName = normalizeTierName(membership?.raw_tier_name || membership?.tier_name);
  const isExpired =
    Boolean(membership?.is_expired) ||
    isMembershipExpired(membership?.expires_at, rawTierName);
  const effectiveTierName = isExpired
    ? 'free'
    : normalizeTierName(membership?.tier_name || rawTierName);

  return {
    rawTierName,
    effectiveTierName,
    isExpired,
  };
}

export function normalizeMembershipPayload(membership) {
  if (!membership) return membership;

  const { rawTierName, effectiveTierName, isExpired } = getMembershipState(membership);

  return {
    ...membership,
    raw_tier_name: rawTierName,
    tier_name: effectiveTierName,
    is_expired: isExpired,
    tier_info:
      isExpired && membership?.tier_info?.name && membership.tier_info.name !== 'free'
        ? null
        : membership?.tier_info || null,
  };
}
